import React, { useContext } from "react";
import Navbar from "../components/Navbar";
import ProfileSquelette from "../layouts/ProfileSquelette";
import ProfileHead from "../components/ProfileHead";
import DetailsPersonnel from "../components/DetailsPersonnel";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import { AuthContext } from "../contexts/AuthContext";
import ChatBot from "../components/chat/Chatbot";

export default function MonProfilePage() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <DisplayDiscussionForMiniScreenProvider>
        <Navbar />
        <ProfileSquelette>
          <ProfileHead
            image={user.userImage}
            prenom={user.prenom}
            nom={user.nom}
            poste={user.poste}
            username={user.username}
            userId={user.userId}
            colors={user.color}
          />
          <div className="tyn-profile-nav">
            <ul className="nav nav-tabs nav-tabs-line">
              <li className="nav-item">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#profile-edit"
                  type="button"
                >
                  Modifier mon profil
                </button>
              </li>
            </ul>
          </div>
          <DetailsPersonnel />
          <ChatBot />
        </ProfileSquelette>
      </DisplayDiscussionForMiniScreenProvider>
    </>
  );
}
